/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowWineTastingTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowWineTasting,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Sip and Savor!",
    "A Toast to the Good Times!",
    "Wine Lovers Unite!",
  ],
  title: "Wine Tasting Event",
  description: "Organize a delightful wine tasting experience.",
  longDescription:
    "Plan a sophisticated wine tasting event. Choose a date, select the wines to taste, and decide on appetizers to pair with them!",
  emoji: "🍷",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Wine Tasting Event",
          emoji: "🍷",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the wine tasting?",
          emoji: "📅",
          completeAction: {
            question: "Decide on which wines to taste?",
            description: "What wines do we want to sample?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "Which wines should we taste?",
                emoji: "🍇",
                completeAction: {
                  question: "Decide on appetizers?",
                  description: "What appetizers should we serve with the wine?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What appetizers should we bring?",
                      emoji: "🧀",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Cheers to a Great Evening!",
    outroDescription:
      "Your wine tasting plans are set! Enjoy the fine wines and company!",
  },
};
